<page-template-component>
  <page-template-header>
     
  </page-template-header>
  <page-template-content>
    <ion-app>
      <ion-row  class="app-main-container">
        <!-- sidebar menu for deskptop view -->
        <ion-col size-md="2" class="ion-no-padding content-web-section">
          <app-nav-menu (initiateTransaction)="openTransactMenu($event)"></app-nav-menu>
        </ion-col>
        <!-- transact sub menu for desktop view -->
        <ion-col class="transact-menu ion-no-padding content-web-section" [ngClass]="{'transact-menu--nfo' : !!schemeCode}" *ngIf="isTransactMenuActive">
          <transact-menu [schemeCode]="schemeCode" [isNewFundOffer]="isNewFundOffer" (transactionSelected)="closeTransactMenu()"></transact-menu>
        </ion-col>
        <!-- main content for application -->
        <ion-col class="ion-no-padding router-outlet-wrap">
          <ion-router-outlet></ion-router-outlet>
        </ion-col>
      </ion-row>
      <!-- menu for mobile view -->
      <ion-row  class="content-mobile-section">
        <div class="transact-menu ion-no-padding" *ngIf="isTransactMenuActive">
          <transact-menu [schemeCode]="schemeCode" [isNewFundOffer]="isNewFundOffer" (transactionSelected)="closeTransactMenu()"></transact-menu>
        </div>
        <ion-footer>
          <app-nav-menu></app-nav-menu>
        </ion-footer>
      </ion-row>
    </ion-app>
  </page-template-content>
</page-template-component>
